import notify from 'devextreme/ui/notify';
import hideToasts from 'devextreme/ui/toast/hide_toasts';
import { NotificationDirections, NotificationPositions, NotificationTypes, NotificationDurations } from './types';

const MAX_VISIBLE = 5;

//
// Уведомлялка с исчезающими сообщениями
// ошибки - 10 с
// предупреждения - 5 с
// успешные - 3 с
// информационные - 3 с
//
export default class DxDisappearingNotifier {
  constructor() {
    this.queue = [];
    this.active = 0;
  }

  showMessage(type, message, duration) {
    this.queue.push({ type, message, duration });

    this.process();
  }

  process() {
    // пока есть место и очередь - показываем
    while (this.active < MAX_VISIBLE && this.queue.length > 0) {
      const item = this.queue.shift();
      this.active++;

      notify({
        message: item.message,
        minWidth: 150,
        type: item.type,
        displayTime: item.duration || NotificationDurations.DEFAULT,
        container: document.body,
        animation: {
          show: { type: 'fade', duration: 200, from: 0, to: 1 },
          hide: { type: 'fade', duration: 100, to: 0 }
        },
        onHidden: () => {
          this.active--;
          this.process(); // освобождаем слот
        }
      }, {
        position: NotificationPositions.BOTTOM_CENTER,
        direction: NotificationDirections.UP_PUSH
      });
    }
  }

  showError(message, duration) {
    this.showMessage(NotificationTypes.ERROR, message, duration || NotificationDurations.ERROR);
  }

  showWarning(message, duration) {
    this.showMessage(NotificationTypes.WARNING, message, duration || NotificationDurations.WARNING);
  }

  showSuccess(message, duration) {
    this.showMessage(NotificationTypes.SUCCESS, message, duration || NotificationDurations.SUCCESS);
  }

  showInfo(message, duration) {
    this.showMessage(NotificationTypes.INFO, message, duration || NotificationDurations.INFO);
  }

  hideAll() {
    hideToasts();
    this.queue = [];
    this.active = 0;
  }
}